import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function ProfileIcon({
	width = 20,
	height = 20,
	color = 'currentColor',
	style,
	active = false,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<path
				d="M15.872 6.18445C15.872 9.6 13.243 12.3689 10 12.3689C6.75702 12.3689 4.12802 9.6 4.12802 6.18445C4.12802 2.7689 6.75702 0 10 0C13.243 0 15.872 2.7689 15.872 6.18445ZM20 20C19.3292 16.2418 15.109 13.3454 10 13.3454C4.89103 13.3454 0.670757 16.2418 0 20H20Z"
				fill={color}
			/>
		</svg>
	);
}
